<!-- 模板放大功能 -->
<template>
  <div class="TemplateZoom">
    <div class="magnify">
      <div
        class="mask"
        :style="{ width: '100%' }"></div>
      <div class="ZoomWrap">
        <!-- 关闭图标 -->
        <div
          class="ZoomClose"
          @click="closeZoom">
          <i class="el-icon-close"></i>
        </div>

        <!-- 头部标题 -->
        <div class="TopTitleWrap">
          <div class="kongbai"></div>
          <div
            class="TopTitle"
            v-for="(item, index) in WeekTitle"
            :key="index"
            :style="{
              width: WeekTitle.length == 1 ? '94.5%' : '13.64%',
            }"
          >
            {{ item }}
          </div>
        </div>
        <!-- 下面表格及内容 -->
        <div class="ZoomCenter">
          <div class="BoxandEvent">
            <!-- 全部事件 -->
            <div class="EventAll">
              <div class="left"></div>
              <div
                class="WeekEvent"
                v-for="(item, index) in WeekTitle"
                :key="index"
                :style="{
                  width: WeekTitle.length == 1 ? '94.5%' : '13.64%',
                }"
              >
                <div
                  v-for="(item1, index1) in EventMessageList"
                  :key="index1">
                  <div
                    class="EventStyle"
                    v-if="index == item1.someday && item1.InScope == 1"
                    :style="item1.style2"
                    :data-device="JSON.stringify(item1)"
                    :data-index="index1"
                    draggable="true"
                    @click="ClickPitchOn(0, item1, index1)"
                  >
                    {{
                      millisecondTime(item1.startTime) +
                        "-" +
                        millisecondTime(item1.endTime) +
                        " " +
                        item1.title
                    }}
                  </div>
                </div>
              </div>
            </div>
            <!-- 盒子 -->
            <div
              class="ZoomScrollWrap"
              id="ZoomScrollWrap">
              <div class="leftBlankWrap">
                <div
                  class="leftBlank"
                  v-for="(item, min) in 30"
                  :key="min">
                  {{ SideTimetransform(min) }}
                </div>
              </div>
              <div
                class="TimeWrap"
                v-for="(item, index) in WeekTitle"
                :key="index"
                :style="{
                  width: WeekTitle.length == 1 ? '94.5%' : '13.64%',
                }"
              >
                <div
                  class="minuteWrap"
                  v-for="(item, min) in 30"
                  :key="min"
                  :data-time="
                    ZoomTime.startTime + index * DayTime + min * 60 * 1000
                  "
                  @click="
                    ClickPitchOn(
                      1,
                      ZoomTime.startTime + index * DayTime + min * 60 * 1000
                    )
                  "
                ></div>
              </div>
            </div>
          </div>
        </div>

        <!-- 下面的操作 -->
        <div
          class="operation"
          v-if="TemplateType == 'format'">
          <div class="cancel">
            <el-button
              type="info"
              size="medium"
              @click="closeZoom"
            >{{$t('lang.cancel')}}</el-button
            >
          </div>
          <div class="save">
            <el-button
              type="success"
              size="medium"
              @click="SaveTemplate"
            >{{$t('lang.save')}}</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../assets/js/utils.js'
import DragMethod from '@/assets/js/common/drag'
import Bus from '@/assets/js/vueBus.js'
import toTips from '@/assets/js/toTipsObj'
export default {
  props: {
    // 查询模板的信息
    TemplateBodyMessage: {
      type: Object,
      default: () => ({})
    },
    // 一周标题
    TemplateSchedule: {
      type: Array,
      default: () => ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    },
    // R的信息
    fixedDevice: Object,
    dynamicDevice: Object,
    // 事件列表
    EventMessageList: {
      type: Array,
      default: () => []
    },
    // 选择放大的时间范围
    ZoomTime: {
      type: Object,
      default: () => ({
        time: '12:0',
        type: 'AM',
        startTime: 0
      })
    }
  },
  data () {
    return {
      // 模板的类型
      TemplateType: 'schedule',
      //   一天的时间
      DayTime: 24 * 60 * 60 * 1000,
      // 每毫秒高度
      secondHeight: 750 / (30 * 60 * 1000),
      //   绑定推拽
      BindDragMethod: ''
    }
  },
  created () {
    if (this.TemplateSchedule.length == 0) {
      this.TemplateType = 'format'
      this.WeekTitle = ['aaa']
    } else {
      this.WeekTitle = this.TemplateSchedule
    }
  },
  watch: {
    //   监听列表变化
    EventMessageList () {
      this.computeEvent()
      this.registerDrag()
    }
  },
  mounted () {
    this.computeEvent()
    this.registerDrag()
    // 左边列表发生变化
    Bus.$on('leftListUpdate', this.registerDrag)
  },
  methods: {
    //   左边列表变化重新绑定拖拽事件
    registerDrag () {
      this.$nextTick(() => {
        this.bindingDrag()
      })
    },
    // 计算事件所占高度以及所处位置
    computeEvent () {
      this.EventMessageList.forEach((item) => {
        // 哪一天
        const someday = Math.floor(item.startTime / this.DayTime)
        // 距离一天开始的时间间隔
        const timeInterval = item.startTime - someday * this.DayTime
        const timeIntervalEnd = item.endTime - someday * this.DayTime
        let style2
        if (
          this.ZoomTime.startTime <= timeInterval &&
          timeInterval < this.ZoomTime.startTime + 30 * 60 * 1000
        ) {
          // 在时间内
          item.InScope = 1
          // 事件时间长度
          const eventTimeLength = item.endTime - item.startTime
          style2 = {
            height: `${this.secondHeight * eventTimeLength}px`,
            position: 'absolute',
            top:
              `${this.secondHeight * (timeInterval - this.ZoomTime.startTime)
              }px`,
            backgroundColor: item.color ? item.color : 'rgb(255, 192, 0)'
          }
        } else if (
          this.ZoomTime.startTime < timeIntervalEnd &&
          timeIntervalEnd <= this.ZoomTime.startTime + 30 * 60 * 1000
        ) {
          // 在时间内
          item.InScope = 1
          // 事件时间长度
          const eventTimeLength =
            item.endTime - someday * this.DayTime - this.ZoomTime.startTime
          style2 = {
            height: `${this.secondHeight * eventTimeLength}px`,
            position: 'absolute',
            top: '0px',
            backgroundColor: item.color ? item.color : 'rgb(255, 192, 0)'
          }
        } else {
          // 不在时间内
          item.InScope = 0
        }

        item.style2 = style2
        item.someday = someday
        return item
      })
      // 强制渲染
      this.$forceUpdate()
    },
    // 弹出弹出框
    ClickPitchOn (type, item1, index1) {
      if (type) {
        this.$emit(
          'ClickEvent',
          1,
          {
            startTime: item1,
            endTime: item1 + 60 * 1000
          },
          index1
        )
      } else {
        this.$emit('ClickEvent', 0, item1, index1)
      }
    },
    //   绑定推拽事件
    bindingDrag () {
      this.BindDragMethod = new DragMethod()
      this.BindDragMethod.create({
        // 拖到的区域
        dropZones: document.getElementById('ZoomScrollWrap'),
        // 被拖动的元素
        from: [
          document.querySelectorAll('.draggable_box .draggable_item'),
          document.querySelectorAll('.BoxandEvent .EventAll .EventStyle')
        ],
        dropEnd: (e) => {
          // e 落下的盒子
          //   盒子初始时间
          const BoxStartTime = Number(e.target.dataset.time)
          //   被拖拽元素数据
          const TargetEvent = JSON.parse(
            this.BindDragMethod.dragElement.dataset.device
          )
          const programTemplate = this.BindDragMethod.dragElement.dataset.programtemplate

          if (programTemplate) {
            this.$message.info(this.$t('lang.forbidTemplate'))
            return
          }
          if (!isNaN(BoxStartTime) && TargetEvent) {
            //  判断是重新创建还是修改  event有值则为修改
            if (TargetEvent.templateId) {
              //   修改事件
              this.DragUpdateEvent(
                BoxStartTime,
                BoxStartTime + 60 * 1000,
                TargetEvent,
                this.BindDragMethod.dragElement.dataset.index
              )
            } else {
              //   创建事件
              this.DragCreateEvent(
                BoxStartTime,
                BoxStartTime + 60 * 1000,
                TargetEvent
              )
            }
          }
        }
      })
    },
    // 拖拽修改事件
    DragUpdateEvent (BoxStartTime, BoxEndTime, TargetEvent) {
      // 删除原本的事件
      this.EventMessageList.splice(
        this.BindDragMethod.dragElement.dataset.index,
        1
      )

      const LastTime = this.getLatelyEvent(BoxStartTime, BoxEndTime)
      //   判断最后一个事件结束时间在不在范围内
      if (LastTime >= BoxStartTime && LastTime < BoxEndTime) {
        const createObject = this.createObject(TargetEvent, LastTime)

        //   判断是否与其他事件冲突
        const IsConflict = this.EventMessageList.some((item) => (
          (item.startTime >= createObject.startTime &&
              item.startTime < createObject.endTime) ||
            (item.endTime > createObject.startTime &&
              item.endTime <= createObject.endTime)
        ))
        if (IsConflict) {
          this.EventMessageList.push(TargetEvent)
          this.$message.error(this.$t('lang.bookingRTimeconflict'))
        } else {
          this.EventMessageList.push(createObject)
        }
      } else if (LastTime >= BoxEndTime) {
        this.EventMessageList.push(TargetEvent)
        this.$message.error(this.$t('lang.bookingRTimeconflict'))
      }
    },
    // 推拽创建事件
    DragCreateEvent (BoxStartTime, BoxEndTime, TargetEvent) {
      const LastTime = this.getLatelyEvent(BoxStartTime, BoxEndTime)
      //   判断最后一个事件结束时间在不在范围内
      if (LastTime >= BoxStartTime && LastTime < BoxEndTime) {
        const createObject = this.createObject(TargetEvent, LastTime)

        //   判断是否与其他事件冲突
        const IsConflict = this.EventMessageList.some((item) => (
          (item.startTime >= createObject.startTime &&
              item.startTime < createObject.endTime) ||
            (item.endTime > createObject.startTime &&
              item.endTime <= createObject.endTime)
        ))
        if (IsConflict) {
          this.$message.error(this.$t('lang.bookingRTimeconflict'))
        } else {
          this.EventMessageList.push(createObject)
        }
      } else if (LastTime >= BoxEndTime) {
        this.$message.error(this.$t('lang.bookingRTimeconflict'))
      }
    },
    // 创建事件对象
    createObject (TargetEvent, LastTime) {
      let EventObject = {
        templateId: this.TemplateBodyMessage.id, // 必传
        bitrate: 5120,
        color: 'rgb(255, 192, 0)',
        delay: 2,
        description: '',
        reporter: '',
        rpeerid: '', // 必传
        scheduleType: 'live', // 必传
        scteId: '',
        title: '', // 必传
        tname: '',
        tpeerid: '', // 必传
        ttype: 'Video', // 必传
        turl: null,
        startTime: 0, // 必传
        endTime: 0 // 必传
      }
      if (TargetEvent.templateId) {
        const Interval = TargetEvent.endTime - TargetEvent.startTime
        // 避免浅拷贝,影响之前数据
        EventObject = JSON.parse(JSON.stringify(TargetEvent))
        EventObject.startTime = LastTime
        EventObject.endTime = LastTime + Interval
      } else if (['file', 'video', 'json', 'tvu'].includes(TargetEvent.type.toLowerCase())) {
        EventObject.rpeerid = this.fixedDevice.peerId
        EventObject.title = TargetEvent.name
        EventObject.tname = TargetEvent.name
        EventObject.tpeerid = TargetEvent.sourceId
        EventObject.startTime = LastTime
        EventObject.endTime = LastTime + Number(TargetEvent.videoTimes) * 1000
      } else {
        EventObject.rpeerid = this.fixedDevice.peerId
        EventObject.title = TargetEvent.name
        EventObject.tname = TargetEvent.name
        EventObject.tpeerid = TargetEvent.peerId
        EventObject.startTime = LastTime
        EventObject.endTime = LastTime + 30 * 60 * 1000
        EventObject.ttype = TargetEvent.type
      }
      return EventObject
    },
    // 获取时间段内最近的一个事件的结束时间
    getLatelyEvent (boxStart, boxEnd) {
      let LastTime = boxStart - 1
      this.EventMessageList.forEach((item) => {
        // 事件的开始或结束在时间段内的
        if (item.endTime >= boxStart && item.endTime <= boxEnd) {
          //   判断哪个最近
          if (LastTime < item.endTime) {
            LastTime = item.endTime
          }
        }
      })

      return LastTime + 1
    },
    // 侧边时间转换
    SideTimetransform (index) {
      const Timeobject = this.ZoomTime.time.split(':')
      let min = `${Number(Timeobject[1]) + index}`
      if (min.length == 1) {
        min = `0${min}`
      }
      return `${Timeobject[0]}:${min} ${this.ZoomTime.type}`
    },
    // 关闭zoom关闭
    closeZoom () {
      this.$emit('closeZoom')
    },
    // 保存模板
    SaveTemplate () {
      const EventMessageList = JSON.parse(JSON.stringify(this.EventMessageList))
      let IsExceed = false
      EventMessageList.forEach((item) => {
        const DayEnd = 30 * 60 * 1000

        if (item.startTime > DayEnd || item.endTime > DayEnd) {
          IsExceed = true
        }
        delete item.someday
        delete item.style
        delete item.userId
      })
      if (IsExceed) {
        this.$message.error(this.$t('lang.ExceedTemplate'))
        return
      }
      this.axios
        .post(utils.getUrl('/template/editTemplateDetail'), EventMessageList)
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message.success(this.$t('lang.success'))
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }).catch(() => {})
    },
    // 毫秒数转换成时分秒
    millisecondTime (time) {
      let hour,
        minute,
        second
      // day = Math.floor(time / (24 * 60 * 60 * 1000));
      hour = Math.floor((time % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000))
      minute = Math.floor((time % (60 * 60 * 1000)) / (60 * 1000))
      second = Math.floor((time % (60 * 1000)) / 1000)
      hour = String(hour).length == 1 ? `0${hour}` : hour
      minute = String(minute).length == 1 ? `0${minute}` : minute
      second = String(second).length == 1 ? `0${second}` : second
      return `${hour}:${minute}:${second}`
    }
  },
  destroyed () {
    Bus.$off('leftListUpdate', this.registerDrag)
  }
}
</script>

<style scoped lang="less">
.magnify {
  width: calc(100% - 516px);
  height: 100%;
  position: fixed;
  top: 0;
  left: 516px;
  z-index: 100;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: #666;
    opacity: 0.5;
    z-index: 100;
  }
  .ZoomWrap {
    width: 80%;
    height: 680px;
    position: absolute;
    left: 50%;
    top: 54%;
    transform: translate(-50%, -50%);
    box-shadow: 0 0 15px #100400;
    background: #333;
    opacity: 1;
    z-index: 106;
    .ZoomClose {
      position: absolute;
      right: 7px;
      top: -30px;
      // width: 14px;
      // height: 14px;
      // background: #333;
      .el-icon-close {
        font-size: 14px;
        border: 1px solid #444;
        padding: 3px;
        background: #333;
      }
    }

    .TopTitleWrap {
      width: calc(100% - 6px);
      height: 22px;
      border-top: 1px solid #555;
      border-bottom: 1px solid #555;
      border-right: 1px solid #555;
      font-weight: 700;
      font-size: 13px;
      display: flex;
      line-height: 22px;
      .kongbai {
        width: 5.5%;
        border-left: 1px solid #555;
      }
      .TopTitle {
        width: 13.64%;
        border-left: 1px solid #555;
      }
    }
    .ZoomCenter {
      height: calc(100% - 52px);
      overflow-y: scroll;
      width: calc(100% - 1px);
      .BoxandEvent {
        overflow: hidden;
      }
      .EventAll {
        display: flex;
        .left {
          border-left: 1px solid #555;
          width: 5.5%;
        }
        .WeekEvent {
          position: relative;
          width: 13.64%;
          .EventStyle {
            width: 100%;
            border-radius: 3px;
            background: #fff;
            font-size: 12px;
            color: #333333;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .ZoomScrollWrap {
        display: flex;
        border-right: 1px solid #555;
        overflow: hidden;
        .leftBlankWrap {
          border-left: 1px solid #555;
          width: 5.5%;
          .leftBlank {
            height: 25px;
            border-bottom: 1px solid #555;
            line-height: 25px;
            font-size: 12px;
          }
        }
        .TimeWrap {
          width: 13.64%;
          height: fit-content;
          border-left: 1px solid #555;
          .minuteWrap {
            height: 25px;
            border-bottom: 1px solid #555;
          }
        }
      }
    }
    .operation {
      display: flex;
      justify-content: flex-end;
      padding: 0px 16px 10px 0;
      .cancel {
        margin-right: 8px;
        ::v-deep .el-button--info {
          width: 100px;
          background-color: #cccccc;
          border-color: #cccccc;
          font-size: 14px;
          color: #333333;
        }
      }
      .save {
        ::v-deep .el-button--success {
          width: 100px;
          background-color: #00cc66;
          border-color: #0f620a;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
  }
}

@media (max-width: 1320px) {
  .magnify {
    width: calc(100% - 450px);
    left: 450px;
    .content {
      width: 90%;
      .td {
        font-size: 11px;
      }
    }
  }
}
@media (max-width: 1070px) {
  .magnify {
    width: calc(100% - 350px);
    left: 350px;
    .content {
      width: 100%;
      .td {
        font-size: 9px;
      }
    }
  }
}
@media (max-width: 1024px) {
  .magnify {
    width: 100%;
    left: 0;
    .content {
      width: 100%;
    }
  }
}
.green {
  background: #0fbe71;
  cursor: pointer;
}
.skyblue {
  background-color: #46c9e1;
  cursor: pointer;
  border-bottom: none !important;
}
.blue {
  background-color: #2f8df4;
  cursor: pointer;
  border-bottom: none !important;
}
.orange {
  background-color: #ffc573;
  cursor: pointer;
  border-bottom: none !important;
}
.pink {
  background-color: #ff6a92;
  cursor: pointer;
  border-bottom: none !important;
}
.yellow {
  background-color: #ffc000;
  cursor: pointer;
  border-bottom: none !important;
}
.purple {
  background-color: #9248c7;
  // border: 1px solid #9248C7;
  border-bottom: none !important;
}
</style>
